import { Box, Typography, TextField } from "@mui/material";
import LookupAutocomplete from "../../../../components/autocomplete/autocomplete";

export type DropdownVm = {
    id: number;
    name: string;
};

interface RecipeMetaSectionProps {
    title: string;
    description: string;

    categoriesSelected: DropdownVm[];   // multi
    categories: DropdownVm[];
    loadingCategories?: boolean;

    onTitleChange: (value: string) => void;
    onDescriptionChange: (value: string) => void;
    onCategoriesChange: (value: DropdownVm[]) => void; // multi
}

export default function RecipeMetaSection({
    title,
    description,
    categoriesSelected,
    categories,
    loadingCategories = false,
    onTitleChange,
    onDescriptionChange,
    onCategoriesChange,
}: RecipeMetaSectionProps) {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Typography variant="h6" fontWeight={600}>
                Recipe details
            </Typography>

            <TextField
                label="Title"
                fullWidth
                value={title}
                onChange={(e) => onTitleChange(e.target.value)}
                placeholder="e.g. Creamy Garlic Chicken Pasta"
            />

            <LookupAutocomplete<DropdownVm>
                label="Categories"
                multiple
                options={categories}
                value={categoriesSelected}
                onChange={onCategoriesChange}
                loading={loadingCategories}
                placeholder="Select categories"
                getOptionLabel={(o) => o.name}
                isOptionEqualToValue={(o, v) => o.id === v.id}
            />

            <TextField
                label="Short description"
                fullWidth
                multiline
                minRows={2}
                value={description}
                onChange={(e) => onDescriptionChange(e.target.value)}
                placeholder="A quick weeknight pasta with chicken, garlic and cream."
            />
        </Box>
    );
}
